import { IndicatorType, SloType } from '@atlassiansox/phobos-client-ts';

import { SLO } from '@/ui';

export type FormState = 'default' | 'submitted';

export const copy: Record<FormState, string> = {
  default: 'Links the below ticket with the currently selected SLO(s)',
  submitted:
    'The ticket is now linked to the selected SLO. ' +
    'This will be reflected in OpsJ below and in the above dashboards.',
};

export const heading: Record<FormState, string> = {
  default: 'Associate Ticket',
  submitted: 'Successfully Linked',
};

export const buttonText: Record<FormState, string> = {
  default: 'Confirm',
  submitted: 'Done',
};

export const skeletonSLO: SLO = {
  name: '',
  description: '',
  type: SloType.Reliability,
  publicId: 'skeleton',
  objective: 0,
  parent: {} as any,
  indicator: {
    publicId: '',
    goodQuery: '',
    badQuery: '',
    isAlertable: false,
    failures: [],
    enabled: true,
    type: IndicatorType.Signalfx,
    lowResolution: true,
    serviceIds: [],
  },
  performance: {
    latestDataPointTimestamp: undefined,
    goodCount: 1,
    badCount: 1,
    result: 0,
    dataPoints: [],
  },
  isDraft: true,
  isCommitted: false,
  lastUpdated: new Date(0),
  sfxEventsQuery: '',
  tag: {},
  manualTag: {},
  isLowPriority: false,
};
